import { subDays } from 'date-fns';
export var mockData = [
    {
        id: 105,
        userId: 11,
        meetingId: 34,
        action: 'MEET_CALL_ENDED',
        eventId: 4670,
        endpoint: 'boq_hlane_tIcsCfsLfMD',
        workspaceId: 6,
        date: subDays(new Date(), 28).toISOString(),
        durationSeconds: 166,
        audioSendSeconds: 166,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 34,
            title: 'Oleg Cherevatyy, Vitalii Melnychuk',
            slugId: 'ujThGK0EU7LftcMxqis3DxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 28).toISOString(),
            workspaceId: 6,
            durationSeconds: 170,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: 11,
            meetingGuests: [
                {
                    id: 144,
                    meetingId: 34,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 145,
                    meetingId: 34,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 104,
        userId: 10,
        meetingId: 34,
        action: 'MEET_CALL_ENDED',
        eventId: 4669,
        endpoint: 'duo_android_5012284951442713807',
        workspaceId: 6,
        date: subDays(new Date(), 28).toISOString(),
        durationSeconds: 170,
        audioSendSeconds: 168,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 34,
            title: 'Oleg Cherevatyy, Vitalii Melnychuk',
            slugId: 'ujThGK0EU7LftcMxqis3DxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 28).toISOString(),
            workspaceId: 6,
            durationSeconds: 170,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 144,
                    meetingId: 34,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 145,
                    meetingId: 34,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 103,
        userId: 7,
        meetingId: 33,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 4667,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 28).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 33,
            title: 'Projectli Daily',
            slugId: 'z3xNXgGaWuxW_ROcqsoNDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 28).toISOString(),
            workspaceId: 6,
            durationSeconds: 209,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: 3,
            meetingGuests: [
                {
                    id: 146,
                    meetingId: 33,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 147,
                    meetingId: 33,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 148,
                    meetingId: 33,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 149,
                    meetingId: 33,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 150,
                    meetingId: 33,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 151,
                    meetingId: 33,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 102,
        userId: 9,
        meetingId: 33,
        action: 'MEET_CALL_ENDED',
        eventId: 4666,
        endpoint: 'boq_hlane_WessLzncjN7',
        workspaceId: 6,
        date: subDays(new Date(), 28).toISOString(),
        durationSeconds: 193,
        audioSendSeconds: 29,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 33,
            title: 'Projectli Daily',
            slugId: 'z3xNXgGaWuxW_ROcqsoNDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 28).toISOString(),
            workspaceId: 6,
            durationSeconds: 209,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: 1,
            meetingGuests: [
                {
                    id: 146,
                    meetingId: 33,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 147,
                    meetingId: 33,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 148,
                    meetingId: 33,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 149,
                    meetingId: 33,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 150,
                    meetingId: 33,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 151,
                    meetingId: 33,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 101,
        userId: 7,
        meetingId: 33,
        action: 'MEET_CALL_ENDED',
        eventId: 4665,
        endpoint: 'boq_hlane_9NVd01YzMXt',
        workspaceId: 6,
        date: subDays(new Date(), 28).toISOString(),
        durationSeconds: 204,
        audioSendSeconds: 153,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 33,
            title: 'Projectli Daily',
            slugId: 'z3xNXgGaWuxW_ROcqsoNDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 28).toISOString(),
            workspaceId: 6,
            durationSeconds: 209,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: 1,
            meetingGuests: [
                {
                    id: 146,
                    meetingId: 33,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 147,
                    meetingId: 33,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 148,
                    meetingId: 33,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 149,
                    meetingId: 33,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 150,
                    meetingId: 33,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 151,
                    meetingId: 33,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 100,
        userId: 1,
        meetingId: 33,
        action: 'MEET_CALL_ENDED',
        eventId: 4664,
        endpoint: 'boq_hlane_d0n7BJOIUtB',
        workspaceId: 6,
        date: subDays(new Date(), 28).toISOString(),
        durationSeconds: 209,
        audioSendSeconds: 209,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 33,
            title: 'Projectli Daily',
            slugId: 'z3xNXgGaWuxW_ROcqsoNDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 28).toISOString(),
            workspaceId: 6,
            durationSeconds: 209,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: 1,
            meetingGuests: [
                {
                    id: 146,
                    meetingId: 33,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 147,
                    meetingId: 33,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 148,
                    meetingId: 33,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 149,
                    meetingId: 33,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 150,
                    meetingId: 33,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 151,
                    meetingId: 33,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 99,
        userId: 11,
        meetingId: 32,
        action: 'MEET_CALL_ENDED',
        eventId: 4663,
        endpoint: 'boq_hlane_M6PTmWBa9cG',
        workspaceId: 6,
        date: subDays(new Date(), 28).toISOString(),
        durationSeconds: 385,
        audioSendSeconds: 384,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 32,
            title: 'Oleg Cherevatyy, Vitalii Melnychuk',
            slugId: 'KyF6viXSmQFOFyPpUuTQDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 28).toISOString(),
            workspaceId: 6,
            durationSeconds: 385,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: 10,
            meetingGuests: [
                {
                    id: 142,
                    meetingId: 32,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 143,
                    meetingId: 32,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 98,
        userId: 10,
        meetingId: 32,
        action: 'MEET_CALL_ENDED',
        eventId: 4662,
        endpoint: 'duo_android_7362146747170704363',
        workspaceId: 6,
        date: subDays(new Date(), 28).toISOString(),
        durationSeconds: 385,
        audioSendSeconds: 380,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 32,
            title: 'Oleg Cherevatyy, Vitalii Melnychuk',
            slugId: 'KyF6viXSmQFOFyPpUuTQDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 28).toISOString(),
            workspaceId: 6,
            durationSeconds: 385,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: 10,
            meetingGuests: [
                {
                    id: 142,
                    meetingId: 32,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 143,
                    meetingId: 32,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 97,
        userId: 3,
        meetingId: 31,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 4543,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 27).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 31,
            title: 'Volodymyr Noha, Oleh Melnychuk, Yevheniia Danylchuk, Oleksandr Burda',
            slugId: 'DPW47tImEJdYi-NenmicDxIPOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 27).toISOString(),
            workspaceId: 6,
            durationSeconds: 1299,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 137,
                    meetingId: 31,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 138,
                    meetingId: 31,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 139,
                    meetingId: 31,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 140,
                    meetingId: 31,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 96,
        userId: 3,
        meetingId: 31,
        action: 'MEET_CALL_ENDED',
        eventId: 4542,
        endpoint: 'boq_hlane_IzG6HUw5scD',
        workspaceId: 6,
        date: subDays(new Date(), 27).toISOString(),
        durationSeconds: 1299,
        audioSendSeconds: 816,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 31,
            title: 'Volodymyr Noha, Oleh Melnychuk, Yevheniia Danylchuk, Oleksandr Burda',
            slugId: 'DPW47tImEJdYi-NenmicDxIPOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 27).toISOString(),
            workspaceId: 6,
            durationSeconds: 1299,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 137,
                    meetingId: 31,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 138,
                    meetingId: 31,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 139,
                    meetingId: 31,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 140,
                    meetingId: 31,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 95,
        userId: 7,
        meetingId: 31,
        action: 'MEET_CALL_ENDED',
        eventId: 4541,
        endpoint: 'boq_hlane_8Sug9ksMdm8',
        workspaceId: 6,
        date: subDays(new Date(), 27).toISOString(),
        durationSeconds: 1261,
        audioSendSeconds: 1151,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 31,
            title: 'Volodymyr Noha, Oleh Melnychuk, Yevheniia Danylchuk, Oleksandr Burda',
            slugId: 'DPW47tImEJdYi-NenmicDxIPOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 27).toISOString(),
            workspaceId: 6,
            durationSeconds: 1299,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 137,
                    meetingId: 31,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 138,
                    meetingId: 31,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 139,
                    meetingId: 31,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 140,
                    meetingId: 31,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 94,
        userId: 1,
        meetingId: 31,
        action: 'MEET_CALL_ENDED',
        eventId: 4540,
        endpoint: 'boq_hlane_wsNa5SCiidH',
        workspaceId: 6,
        date: subDays(new Date(), 27).toISOString(),
        durationSeconds: 1285,
        audioSendSeconds: 1177,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 31,
            title: 'Volodymyr Noha, Oleh Melnychuk, Yevheniia Danylchuk, Oleksandr Burda',
            slugId: 'DPW47tImEJdYi-NenmicDxIPOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 27).toISOString(),
            workspaceId: 6,
            durationSeconds: 1299,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 137,
                    meetingId: 31,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 138,
                    meetingId: 31,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 139,
                    meetingId: 31,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 140,
                    meetingId: 31,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 93,
        userId: 9,
        meetingId: 31,
        action: 'MEET_CALL_ENDED',
        eventId: 4539,
        endpoint: 'boq_hlane_RDyMKYg2oDU',
        workspaceId: 6,
        date: subDays(new Date(), 27).toISOString(),
        durationSeconds: 1282,
        audioSendSeconds: 42,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 31,
            title: 'Volodymyr Noha, Oleh Melnychuk, Yevheniia Danylchuk, Oleksandr Burda',
            slugId: 'DPW47tImEJdYi-NenmicDxIPOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 27).toISOString(),
            workspaceId: 6,
            durationSeconds: 1299,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 137,
                    meetingId: 31,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 138,
                    meetingId: 31,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 139,
                    meetingId: 31,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 140,
                    meetingId: 31,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 92,
        userId: 7,
        meetingId: 30,
        action: 'MEET_CALL_ENDED',
        eventId: 4189,
        endpoint: 'boq_hlane_xLkZ4aXAONm',
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 772,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 30,
            title: 'Yevheniia Danylchuk',
            slugId: '4hrZxrlzifKpOyW13gzcDxISOA8MCwMyBwiKAiAAGAMI',
            calendarId: 11,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 772,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: 7,
            meetingGuests: [
                {
                    id: 141,
                    meetingId: 30,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 91,
        userId: 7,
        meetingId: 29,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 4188,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 29,
            title: 'Yevheniia Danylchuk',
            slugId: 'Irh3gywFeXTWKp4SoIVwDxISOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 57,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: 7,
            meetingGuests: [
                {
                    id: 129,
                    meetingId: 29,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 90,
        userId: 7,
        meetingId: 29,
        action: 'MEET_PRESENTATION_STOPPED',
        eventId: 4187,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 29,
            title: 'Yevheniia Danylchuk',
            slugId: 'Irh3gywFeXTWKp4SoIVwDxISOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 57,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: 7,
            meetingGuests: [
                {
                    id: 129,
                    meetingId: 29,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 89,
        userId: 7,
        meetingId: 29,
        action: 'MEET_CALL_ENDED',
        eventId: 4186,
        endpoint: 'boq_hlane_MLq4Yvfwy1X',
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 57,
        audioSendSeconds: 42,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 29,
            title: 'Yevheniia Danylchuk',
            slugId: 'Irh3gywFeXTWKp4SoIVwDxISOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 57,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: 7,
            meetingGuests: [
                {
                    id: 129,
                    meetingId: 29,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 88,
        userId: 1,
        meetingId: 28,
        action: 'MEET_CALL_ENDED',
        eventId: 4169,
        endpoint: 'boq_hlane_aHCaLwoZkGk',
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 230,
        audioSendSeconds: 220,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 28,
            title: 'Projectli Daily',
            slugId: 'rQ5oTZBt3jw96SKF3XbJDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 230,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: 1,
            meetingGuests: [
                {
                    id: 130,
                    meetingId: 28,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 131,
                    meetingId: 28,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 132,
                    meetingId: 28,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 133,
                    meetingId: 28,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 134,
                    meetingId: 28,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 135,
                    meetingId: 28,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 87,
        userId: 9,
        meetingId: 28,
        action: 'MEET_CALL_ENDED',
        eventId: 4168,
        endpoint: 'boq_hlane_ukhWDsADAyj',
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 227,
        audioSendSeconds: 31,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 28,
            title: 'Projectli Daily',
            slugId: 'rQ5oTZBt3jw96SKF3XbJDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 230,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: 1,
            meetingGuests: [
                {
                    id: 130,
                    meetingId: 28,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 131,
                    meetingId: 28,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 132,
                    meetingId: 28,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 133,
                    meetingId: 28,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 134,
                    meetingId: 28,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 135,
                    meetingId: 28,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 86,
        userId: 7,
        meetingId: 28,
        action: 'MEET_CALL_ENDED',
        eventId: 4167,
        endpoint: 'boq_hlane_NGZ4e9xqhjk',
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 229,
        audioSendSeconds: 219,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 28,
            title: 'Projectli Daily',
            slugId: 'rQ5oTZBt3jw96SKF3XbJDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 230,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: 1,
            meetingGuests: [
                {
                    id: 130,
                    meetingId: 28,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 131,
                    meetingId: 28,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 132,
                    meetingId: 28,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 133,
                    meetingId: 28,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 134,
                    meetingId: 28,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 135,
                    meetingId: 28,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 85,
        userId: 7,
        meetingId: 27,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 4125,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 27,
            title: 'Yevheniia Danylchuk',
            slugId: 'ch0F4I1A56WQLf0UcpXNDxISOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 100,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: 7,
            meetingGuests: [
                {
                    id: 128,
                    meetingId: 27,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 84,
        userId: 7,
        meetingId: 27,
        action: 'MEET_CALL_ENDED',
        eventId: 4124,
        endpoint: 'boq_hlane_zvDS1gqBGBO',
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 100,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 27,
            title: 'Yevheniia Danylchuk',
            slugId: 'ch0F4I1A56WQLf0UcpXNDxISOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 100,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: 7,
            meetingGuests: [
                {
                    id: 128,
                    meetingId: 27,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 83,
        userId: 7,
        meetingId: 26,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 4123,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 26,
            title: 'test meet',
            slugId: 'YNSicNtmu51yE1P-ti7uDxISOA8MCwMyBwiKAiAAGAMI',
            calendarId: 9,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 248,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: []
        }
    },
    {
        id: 82,
        userId: 7,
        meetingId: 26,
        action: 'MEET_CALL_ENDED',
        eventId: 4122,
        endpoint: 'boq_hlane_haIiI5d5xjF',
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 248,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 26,
            title: 'test meet',
            slugId: 'YNSicNtmu51yE1P-ti7uDxISOA8MCwMyBwiKAiAAGAMI',
            calendarId: 9,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 248,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: []
        }
    },
    {
        id: 81,
        userId: 11,
        meetingId: 25,
        action: 'MEET_CALL_ENDED',
        eventId: 4120,
        endpoint: 'boq_hlane_fMu4OuxEySX',
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 247,
        audioSendSeconds: 247,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 25,
            title: 'Oleksandr Burda, Vitalii Melnychuk',
            slugId: 'JjJC1HlIPf1e0vgTETFsDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 247,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 119,
                    meetingId: 25,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 120,
                    meetingId: 25,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 80,
        userId: 9,
        meetingId: 25,
        action: 'MEET_CALL_ENDED',
        eventId: 4119,
        endpoint: 'boq_hlane_XIU3IHGAtDz',
        workspaceId: 6,
        date: subDays(new Date(), 26).toISOString(),
        durationSeconds: 242,
        audioSendSeconds: 242,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 25,
            title: 'Oleksandr Burda, Vitalii Melnychuk',
            slugId: 'JjJC1HlIPf1e0vgTETFsDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 26).toISOString(),
            workspaceId: 6,
            durationSeconds: 247,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 119,
                    meetingId: 25,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 120,
                    meetingId: 25,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 79,
        userId: 3,
        meetingId: 24,
        action: 'MEET_CALL_ENDED',
        eventId: 4117,
        endpoint: 'boq_hlane_U7T5heVkKu0',
        workspaceId: 6,
        date: subDays(new Date(), 25).toISOString(),
        durationSeconds: 951,
        audioSendSeconds: 920,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 24,
            title: 'Projectli Daily',
            slugId: 'M4owMy1fqy2_PuqXG7HhDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 25).toISOString(),
            workspaceId: 6,
            durationSeconds: 1561,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 121,
                    meetingId: 24,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 122,
                    meetingId: 24,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 123,
                    meetingId: 24,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 124,
                    meetingId: 24,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 125,
                    meetingId: 24,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 126,
                    meetingId: 24,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 78,
        userId: 9,
        meetingId: 24,
        action: 'MEET_CALL_ENDED',
        eventId: 4116,
        endpoint: 'boq_hlane_FZ8bUasRzEc',
        workspaceId: 6,
        date: subDays(new Date(), 25).toISOString(),
        durationSeconds: 1551,
        audioSendSeconds: 40,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 24,
            title: 'Projectli Daily',
            slugId: 'M4owMy1fqy2_PuqXG7HhDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 25).toISOString(),
            workspaceId: 6,
            durationSeconds: 1561,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: 1,
            meetingGuests: [
                {
                    id: 121,
                    meetingId: 24,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 122,
                    meetingId: 24,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 123,
                    meetingId: 24,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 124,
                    meetingId: 24,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 125,
                    meetingId: 24,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 126,
                    meetingId: 24,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 77,
        userId: 1,
        meetingId: 24,
        action: 'MEET_CALL_ENDED',
        eventId: 4115,
        endpoint: 'boq_hlane_fz2OA9gQk6R',
        workspaceId: 6,
        date: subDays(new Date(), 25).toISOString(),
        durationSeconds: 1537,
        audioSendSeconds: 833,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 24,
            title: 'Projectli Daily',
            slugId: 'M4owMy1fqy2_PuqXG7HhDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 25).toISOString(),
            workspaceId: 6,
            durationSeconds: 1561,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: 1,
            meetingGuests: [
                {
                    id: 121,
                    meetingId: 24,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 122,
                    meetingId: 24,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 123,
                    meetingId: 24,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 124,
                    meetingId: 24,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 125,
                    meetingId: 24,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 126,
                    meetingId: 24,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 76,
        userId: 7,
        meetingId: 24,
        action: 'MEET_CALL_ENDED',
        eventId: 4114,
        endpoint: 'boq_hlane_LOWGJAKVXk5',
        workspaceId: 6,
        date: subDays(new Date(), 25).toISOString(),
        durationSeconds: 1561,
        audioSendSeconds: 133,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 24,
            title: 'Projectli Daily',
            slugId: 'M4owMy1fqy2_PuqXG7HhDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 25).toISOString(),
            workspaceId: 6,
            durationSeconds: 1561,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: 7,
            meetingGuests: [
                {
                    id: 121,
                    meetingId: 24,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 122,
                    meetingId: 24,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 123,
                    meetingId: 24,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 124,
                    meetingId: 24,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 125,
                    meetingId: 24,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 126,
                    meetingId: 24,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 75,
        userId: 13,
        meetingId: 23,
        action: 'MEET_CALL_ENDED',
        eventId: 3911,
        endpoint: 'boq_hlane_7MW4wxuaH85',
        workspaceId: 6,
        date: subDays(new Date(), 23).toISOString(),
        durationSeconds: 6868,
        audioSendSeconds: 6868,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: true,
        meeting: {
            id: 23,
            title: 'Vitalii / Oleg',
            slugId: '2xZjOcyR92tcFBdVY_8CDxIUOA8MCwMyBwiKAiAAGAMI',
            calendarId: 3,
            date: subDays(new Date(), 23).toISOString(),
            workspaceId: 6,
            durationSeconds: 6868,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 268,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 117,
                    meetingId: 23,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 118,
                    meetingId: 23,
                    userId: 13,
                    isExternal: true,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 74,
        userId: 11,
        meetingId: 23,
        action: 'MEET_CALL_ENDED',
        eventId: 3910,
        endpoint: 'boq_hlane_5OkyIeHmaD1',
        workspaceId: 6,
        date: subDays(new Date(), 23).toISOString(),
        durationSeconds: 6726,
        audioSendSeconds: 6726,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 23,
            title: 'Vitalii / Oleg',
            slugId: '2xZjOcyR92tcFBdVY_8CDxIUOA8MCwMyBwiKAiAAGAMI',
            calendarId: 3,
            date: subDays(new Date(), 23).toISOString(),
            workspaceId: 6,
            durationSeconds: 6868,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 268,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 117,
                    meetingId: 23,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 118,
                    meetingId: 23,
                    userId: 13,
                    isExternal: true,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 73,
        userId: 1,
        meetingId: 22,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 3697,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 22).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 22,
            title: 'Projectli Planning',
            slugId: '8xyi3cAJtpaggZNPiDVXDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 22).toISOString(),
            workspaceId: 6,
            durationSeconds: 1067,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 109,
                    meetingId: 22,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 110,
                    meetingId: 22,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 111,
                    meetingId: 22,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 112,
                    meetingId: 22,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 113,
                    meetingId: 22,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 114,
                    meetingId: 22,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 115,
                    meetingId: 22,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 72,
        userId: 7,
        meetingId: 22,
        action: 'MEET_KNOCKING_ACCEPTED',
        eventId: 3696,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 22).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 22,
            title: 'Projectli Planning',
            slugId: '8xyi3cAJtpaggZNPiDVXDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 22).toISOString(),
            workspaceId: 6,
            durationSeconds: 1067,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 109,
                    meetingId: 22,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 110,
                    meetingId: 22,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 111,
                    meetingId: 22,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 112,
                    meetingId: 22,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 113,
                    meetingId: 22,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 114,
                    meetingId: 22,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 115,
                    meetingId: 22,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 71,
        userId: 9,
        meetingId: 22,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 3695,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 22).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 22,
            title: 'Projectli Planning',
            slugId: '8xyi3cAJtpaggZNPiDVXDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 22).toISOString(),
            workspaceId: 6,
            durationSeconds: 1067,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 109,
                    meetingId: 22,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 110,
                    meetingId: 22,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 111,
                    meetingId: 22,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 112,
                    meetingId: 22,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 113,
                    meetingId: 22,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 114,
                    meetingId: 22,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 115,
                    meetingId: 22,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 70,
        userId: 11,
        meetingId: 22,
        action: 'MEET_CALL_ENDED',
        eventId: 3694,
        endpoint: 'boq_hlane_mrt15FFCQd7',
        workspaceId: 6,
        date: subDays(new Date(), 22).toISOString(),
        durationSeconds: 1040,
        audioSendSeconds: 1040,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 22,
            title: 'Projectli Planning',
            slugId: '8xyi3cAJtpaggZNPiDVXDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 22).toISOString(),
            workspaceId: 6,
            durationSeconds: 1067,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 109,
                    meetingId: 22,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 110,
                    meetingId: 22,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 111,
                    meetingId: 22,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 112,
                    meetingId: 22,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 113,
                    meetingId: 22,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 114,
                    meetingId: 22,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 115,
                    meetingId: 22,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 69,
        userId: 14,
        meetingId: 22,
        action: 'MEET_CALL_ENDED',
        eventId: 3693,
        endpoint: 'duo_ios_MPfZKVW8evA',
        workspaceId: 6,
        date: subDays(new Date(), 22).toISOString(),
        durationSeconds: 934,
        audioSendSeconds: 69,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: true,
        meeting: {
            id: 22,
            title: 'Projectli Planning',
            slugId: '8xyi3cAJtpaggZNPiDVXDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 22).toISOString(),
            workspaceId: 6,
            durationSeconds: 1067,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 109,
                    meetingId: 22,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 110,
                    meetingId: 22,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 111,
                    meetingId: 22,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 112,
                    meetingId: 22,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 113,
                    meetingId: 22,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 114,
                    meetingId: 22,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 115,
                    meetingId: 22,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 68,
        userId: 7,
        meetingId: 22,
        action: 'MEET_CALL_ENDED',
        eventId: 3692,
        endpoint: 'boq_hlane_FWal83ZlvPx',
        workspaceId: 6,
        date: subDays(new Date(), 22).toISOString(),
        durationSeconds: 1067,
        audioSendSeconds: 273,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 22,
            title: 'Projectli Planning',
            slugId: '8xyi3cAJtpaggZNPiDVXDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 22).toISOString(),
            workspaceId: 6,
            durationSeconds: 1067,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 109,
                    meetingId: 22,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 110,
                    meetingId: 22,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 111,
                    meetingId: 22,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 112,
                    meetingId: 22,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 113,
                    meetingId: 22,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 114,
                    meetingId: 22,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 115,
                    meetingId: 22,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 67,
        userId: 9,
        meetingId: 22,
        action: 'MEET_CALL_ENDED',
        eventId: 3691,
        endpoint: 'boq_hlane_fQ1yyiIRUAo',
        workspaceId: 6,
        date: subDays(new Date(), 22).toISOString(),
        durationSeconds: 1057,
        audioSendSeconds: 247,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 22,
            title: 'Projectli Planning',
            slugId: '8xyi3cAJtpaggZNPiDVXDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 22).toISOString(),
            workspaceId: 6,
            durationSeconds: 1067,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 109,
                    meetingId: 22,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 110,
                    meetingId: 22,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 111,
                    meetingId: 22,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 112,
                    meetingId: 22,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 113,
                    meetingId: 22,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 114,
                    meetingId: 22,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 115,
                    meetingId: 22,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 66,
        userId: 1,
        meetingId: 22,
        action: 'MEET_CALL_ENDED',
        eventId: 3690,
        endpoint: 'boq_hlane_8U21XOUTZ4t',
        workspaceId: 6,
        date: subDays(new Date(), 22).toISOString(),
        durationSeconds: 1059,
        audioSendSeconds: 371,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 22,
            title: 'Projectli Planning',
            slugId: '8xyi3cAJtpaggZNPiDVXDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 22).toISOString(),
            workspaceId: 6,
            durationSeconds: 1067,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 109,
                    meetingId: 22,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 110,
                    meetingId: 22,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 111,
                    meetingId: 22,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 112,
                    meetingId: 22,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 113,
                    meetingId: 22,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 114,
                    meetingId: 22,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 115,
                    meetingId: 22,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 65,
        userId: 11,
        meetingId: 21,
        action: 'MEET_KNOCKING_ACCEPTED',
        eventId: 3592,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 21).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 21,
            title: 'Yaroslav / Vitalii',
            slugId: 'egs96SfqkOKI97yeRbFUDxIQOA8MCwMyBwiKAiAAGAEI',
            calendarId: 8,
            date: subDays(new Date(), 21).toISOString(),
            workspaceId: 6,
            durationSeconds: 172,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 108,
                    meetingId: 21,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 64,
        userId: 11,
        meetingId: 21,
        action: 'MEET_CALL_ENDED',
        eventId: 3591,
        endpoint: 'boq_hlane_CyANFCSIWRR',
        workspaceId: 6,
        date: subDays(new Date(), 21).toISOString(),
        durationSeconds: 172,
        audioSendSeconds: 172,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 21,
            title: 'Yaroslav / Vitalii',
            slugId: 'egs96SfqkOKI97yeRbFUDxIQOA8MCwMyBwiKAiAAGAEI',
            calendarId: 8,
            date: subDays(new Date(), 21).toISOString(),
            workspaceId: 6,
            durationSeconds: 172,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 108,
                    meetingId: 21,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 63,
        userId: 14,
        meetingId: 21,
        action: 'MEET_CALL_ENDED',
        eventId: 3590,
        endpoint: 'duo_ios_KdEExCSL600',
        workspaceId: 6,
        date: subDays(new Date(), 21).toISOString(),
        durationSeconds: 168,
        audioSendSeconds: 159,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: true,
        meeting: {
            id: 21,
            title: 'Yaroslav / Vitalii',
            slugId: 'egs96SfqkOKI97yeRbFUDxIQOA8MCwMyBwiKAiAAGAEI',
            calendarId: 8,
            date: subDays(new Date(), 21).toISOString(),
            workspaceId: 6,
            durationSeconds: 172,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 108,
                    meetingId: 21,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 62,
        userId: 3,
        meetingId: 20,
        action: 'MEET_CALL_ENDED',
        eventId: 3577,
        endpoint: 'boq_hlane_rg73nJUJDE6',
        workspaceId: 6,
        date: subDays(new Date(), 21).toISOString(),
        durationSeconds: 328,
        audioSendSeconds: 328,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 20,
            title: 'Projectli Daily',
            slugId: 'FXNMbP4rmEcGSaz-unVpDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 21).toISOString(),
            workspaceId: 6,
            durationSeconds: 633,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 101,
                    meetingId: 20,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 102,
                    meetingId: 20,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 103,
                    meetingId: 20,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 104,
                    meetingId: 20,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 105,
                    meetingId: 20,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 106,
                    meetingId: 20,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 61,
        userId: 1,
        meetingId: 20,
        action: 'MEET_CALL_ENDED',
        eventId: 3576,
        endpoint: 'boq_hlane_k1xxvZBMyKU',
        workspaceId: 6,
        date: subDays(new Date(), 21).toISOString(),
        durationSeconds: 626,
        audioSendSeconds: 159,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 20,
            title: 'Projectli Daily',
            slugId: 'FXNMbP4rmEcGSaz-unVpDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 21).toISOString(),
            workspaceId: 6,
            durationSeconds: 633,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 101,
                    meetingId: 20,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 102,
                    meetingId: 20,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 103,
                    meetingId: 20,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 104,
                    meetingId: 20,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 105,
                    meetingId: 20,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 106,
                    meetingId: 20,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 60,
        userId: 9,
        meetingId: 20,
        action: 'MEET_CALL_ENDED',
        eventId: 3575,
        endpoint: 'boq_hlane_qFlfUFIUMVt',
        workspaceId: 6,
        date: subDays(new Date(), 21).toISOString(),
        durationSeconds: 624,
        audioSendSeconds: 49,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 20,
            title: 'Projectli Daily',
            slugId: 'FXNMbP4rmEcGSaz-unVpDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 21).toISOString(),
            workspaceId: 6,
            durationSeconds: 633,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 101,
                    meetingId: 20,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 102,
                    meetingId: 20,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 103,
                    meetingId: 20,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 104,
                    meetingId: 20,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 105,
                    meetingId: 20,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 106,
                    meetingId: 20,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 59,
        userId: 7,
        meetingId: 20,
        action: 'MEET_CALL_ENDED',
        eventId: 3574,
        endpoint: 'boq_hlane_1Z7ZUDsvtQW',
        workspaceId: 6,
        date: subDays(new Date(), 21).toISOString(),
        durationSeconds: 633,
        audioSendSeconds: 310,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 20,
            title: 'Projectli Daily',
            slugId: 'FXNMbP4rmEcGSaz-unVpDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 21).toISOString(),
            workspaceId: 6,
            durationSeconds: 633,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 101,
                    meetingId: 20,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 102,
                    meetingId: 20,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 103,
                    meetingId: 20,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 104,
                    meetingId: 20,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 105,
                    meetingId: 20,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 106,
                    meetingId: 20,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 58,
        userId: 7,
        meetingId: 19,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 2918,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 20).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 19,
            title: 'Projectli Daily',
            slugId: '3iJXvDpOTsQYEM5RES13DxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 20).toISOString(),
            workspaceId: 6,
            durationSeconds: 1427,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 94,
                    meetingId: 19,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 95,
                    meetingId: 19,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 96,
                    meetingId: 19,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 97,
                    meetingId: 19,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 98,
                    meetingId: 19,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 99,
                    meetingId: 19,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 57,
        userId: 3,
        meetingId: 19,
        action: 'MEET_CALL_ENDED',
        eventId: 2917,
        endpoint: 'boq_hlane_3nPGMesitXY',
        workspaceId: 6,
        date: subDays(new Date(), 20).toISOString(),
        durationSeconds: 1379,
        audioSendSeconds: 1325,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 19,
            title: 'Projectli Daily',
            slugId: '3iJXvDpOTsQYEM5RES13DxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 20).toISOString(),
            workspaceId: 6,
            durationSeconds: 1427,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 94,
                    meetingId: 19,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 95,
                    meetingId: 19,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 96,
                    meetingId: 19,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 97,
                    meetingId: 19,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 98,
                    meetingId: 19,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 99,
                    meetingId: 19,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 56,
        userId: 1,
        meetingId: 19,
        action: 'MEET_CALL_ENDED',
        eventId: 2916,
        endpoint: 'boq_hlane_flNV80cVMTl',
        workspaceId: 6,
        date: subDays(new Date(), 20).toISOString(),
        durationSeconds: 1383,
        audioSendSeconds: 1136,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 19,
            title: 'Projectli Daily',
            slugId: '3iJXvDpOTsQYEM5RES13DxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 20).toISOString(),
            workspaceId: 6,
            durationSeconds: 1427,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 94,
                    meetingId: 19,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 95,
                    meetingId: 19,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 96,
                    meetingId: 19,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 97,
                    meetingId: 19,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 98,
                    meetingId: 19,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 99,
                    meetingId: 19,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 55,
        userId: 7,
        meetingId: 19,
        action: 'MEET_CALL_ENDED',
        eventId: 2915,
        endpoint: 'boq_hlane_NVS0kozSuys',
        workspaceId: 6,
        date: subDays(new Date(), 20).toISOString(),
        durationSeconds: 1368,
        audioSendSeconds: 620,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 19,
            title: 'Projectli Daily',
            slugId: '3iJXvDpOTsQYEM5RES13DxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 20).toISOString(),
            workspaceId: 6,
            durationSeconds: 1427,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 94,
                    meetingId: 19,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 95,
                    meetingId: 19,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 96,
                    meetingId: 19,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 97,
                    meetingId: 19,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 98,
                    meetingId: 19,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 99,
                    meetingId: 19,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 54,
        userId: 9,
        meetingId: 19,
        action: 'MEET_CALL_ENDED',
        eventId: 2914,
        endpoint: 'boq_hlane_6uB3LqGavSa',
        workspaceId: 6,
        date: subDays(new Date(), 20).toISOString(),
        durationSeconds: 1427,
        audioSendSeconds: 120,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 19,
            title: 'Projectli Daily',
            slugId: '3iJXvDpOTsQYEM5RES13DxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 20).toISOString(),
            workspaceId: 6,
            durationSeconds: 1427,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 94,
                    meetingId: 19,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 95,
                    meetingId: 19,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 96,
                    meetingId: 19,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 97,
                    meetingId: 19,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 98,
                    meetingId: 19,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 99,
                    meetingId: 19,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 53,
        userId: 7,
        meetingId: 18,
        action: 'MEET_CALL_ENDED',
        eventId: 2863,
        endpoint: 'boq_hlane_Opsp2Oj9RGp',
        workspaceId: 6,
        date: subDays(new Date(), 20).toISOString(),
        durationSeconds: 185,
        audioSendSeconds: 184,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 18,
            title: 'Yevheniia Danylchuk',
            slugId: 'YAnutLlJsJk9GE8kZXTGDxISOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 20).toISOString(),
            workspaceId: 6,
            durationSeconds: 185,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 86,
                    meetingId: 18,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 52,
        userId: 7,
        meetingId: 17,
        action: 'MEET_CALL_ENDED',
        eventId: 2857,
        endpoint: 'boq_hlane_cA85xf98mJF',
        workspaceId: 6,
        date: subDays(new Date(), 20).toISOString(),
        durationSeconds: 77,
        audioSendSeconds: 76,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 17,
            title: 'Yevheniia Danylchuk',
            slugId: '1_aEAH7XoRymnHeCk8mwDxISOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 20).toISOString(),
            workspaceId: 6,
            durationSeconds: 77,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 85,
                    meetingId: 17,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 51,
        userId: 3,
        meetingId: 16,
        action: 'MEET_CALL_ENDED',
        eventId: 2830,
        endpoint: 'boq_hlane_LNdSTRjBZHM',
        workspaceId: 6,
        date: subDays(new Date(), 19).toISOString(),
        durationSeconds: 192,
        audioSendSeconds: 191,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 16,
            title: 'Projectli Daily',
            slugId: '2z27fkacqz-M1xmae0UADxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 19).toISOString(),
            workspaceId: 6,
            durationSeconds: 193,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 87,
                    meetingId: 16,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 88,
                    meetingId: 16,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 89,
                    meetingId: 16,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 90,
                    meetingId: 16,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 91,
                    meetingId: 16,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 92,
                    meetingId: 16,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 50,
        userId: 7,
        meetingId: 16,
        action: 'MEET_CALL_ENDED',
        eventId: 2829,
        endpoint: 'boq_hlane_rk3obPTsBsb',
        workspaceId: 6,
        date: subDays(new Date(), 19).toISOString(),
        durationSeconds: 160,
        audioSendSeconds: 73,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 16,
            title: 'Projectli Daily',
            slugId: '2z27fkacqz-M1xmae0UADxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 19).toISOString(),
            workspaceId: 6,
            durationSeconds: 193,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 87,
                    meetingId: 16,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 88,
                    meetingId: 16,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 89,
                    meetingId: 16,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 90,
                    meetingId: 16,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 91,
                    meetingId: 16,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 92,
                    meetingId: 16,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 49,
        userId: 9,
        meetingId: 16,
        action: 'MEET_CALL_ENDED',
        eventId: 2828,
        endpoint: 'boq_hlane_ZftOudQB1fi',
        workspaceId: 6,
        date: subDays(new Date(), 19).toISOString(),
        durationSeconds: 193,
        audioSendSeconds: 75,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 16,
            title: 'Projectli Daily',
            slugId: '2z27fkacqz-M1xmae0UADxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 19).toISOString(),
            workspaceId: 6,
            durationSeconds: 193,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 87,
                    meetingId: 16,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 88,
                    meetingId: 16,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 89,
                    meetingId: 16,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 90,
                    meetingId: 16,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 91,
                    meetingId: 16,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 92,
                    meetingId: 16,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 48,
        userId: 1,
        meetingId: 15,
        action: 'MEET_CALL_ENDED',
        eventId: 2695,
        endpoint: 'boq_hlane_0m4o5RXKp8c',
        workspaceId: 6,
        date: subDays(new Date(), 18).toISOString(),
        durationSeconds: 66,
        audioSendSeconds: 66,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 15,
            title: 'Projectli Daily',
            slugId: 'CGCvg0-9xpXMLwGaIQQrDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 18).toISOString(),
            workspaceId: 6,
            durationSeconds: 102,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 78,
                    meetingId: 15,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 79,
                    meetingId: 15,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 80,
                    meetingId: 15,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 81,
                    meetingId: 15,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 82,
                    meetingId: 15,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 83,
                    meetingId: 15,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 47,
        userId: 7,
        meetingId: 15,
        action: 'MEET_CALL_ENDED',
        eventId: 2694,
        endpoint: 'hub_ios_eM89nvAPwwk',
        workspaceId: 6,
        date: subDays(new Date(), 18).toISOString(),
        durationSeconds: 102,
        audioSendSeconds: 51,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 15,
            title: 'Projectli Daily',
            slugId: 'CGCvg0-9xpXMLwGaIQQrDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 18).toISOString(),
            workspaceId: 6,
            durationSeconds: 102,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 78,
                    meetingId: 15,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 79,
                    meetingId: 15,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 80,
                    meetingId: 15,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 81,
                    meetingId: 15,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 82,
                    meetingId: 15,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 83,
                    meetingId: 15,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 46,
        userId: 9,
        meetingId: 15,
        action: 'MEET_CALL_ENDED',
        eventId: 2693,
        endpoint: 'boq_hlane_ZSgrTGLbBC8',
        workspaceId: 6,
        date: subDays(new Date(), 18).toISOString(),
        durationSeconds: 78,
        audioSendSeconds: 24,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 15,
            title: 'Projectli Daily',
            slugId: 'CGCvg0-9xpXMLwGaIQQrDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 18).toISOString(),
            workspaceId: 6,
            durationSeconds: 102,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 78,
                    meetingId: 15,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 79,
                    meetingId: 15,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 80,
                    meetingId: 15,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 81,
                    meetingId: 15,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 82,
                    meetingId: 15,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 83,
                    meetingId: 15,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 45,
        userId: 11,
        meetingId: 14,
        action: 'MEET_CALL_ENDED',
        eventId: 2203,
        endpoint: 'boq_hlane_Acd9NAY8pmG',
        workspaceId: 6,
        date: subDays(new Date(), 16).toISOString(),
        durationSeconds: 6223,
        audioSendSeconds: 6223,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 14,
            title: 'Vitalii / Oleg',
            slugId: 'JSTuQ-UwMjf1OK2NJXIADxIUOA8MCwMyBwiKAiAAGAMI',
            calendarId: 3,
            date: subDays(new Date(), 16).toISOString(),
            workspaceId: 6,
            durationSeconds: 6282,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 76,
                    meetingId: 14,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 77,
                    meetingId: 14,
                    userId: 13,
                    isExternal: true,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 44,
        userId: 13,
        meetingId: 14,
        action: 'MEET_CALL_ENDED',
        eventId: 2200,
        endpoint: 'boq_hlane_w4B63Y98F0r',
        workspaceId: 6,
        date: subDays(new Date(), 16).toISOString(),
        durationSeconds: 6282,
        audioSendSeconds: 6271,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: true,
        meeting: {
            id: 14,
            title: 'Vitalii / Oleg',
            slugId: 'JSTuQ-UwMjf1OK2NJXIADxIUOA8MCwMyBwiKAiAAGAMI',
            calendarId: 3,
            date: subDays(new Date(), 16).toISOString(),
            workspaceId: 6,
            durationSeconds: 6282,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 76,
                    meetingId: 14,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 77,
                    meetingId: 14,
                    userId: 13,
                    isExternal: true,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 43,
        userId: 2,
        meetingId: 13,
        action: 'MEET_CALL_ENDED',
        eventId: 1868,
        endpoint: 'boq_hlane_nvlkC1keeVw',
        workspaceId: 6,
        date: subDays(new Date(), 15).toISOString(),
        durationSeconds: 2617,
        audioSendSeconds: 2615,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 13,
            title: 'Dmytro Savytsky',
            slugId: 'FBe433UZkJNeHg96E4c6DxIUOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 16).toISOString(),
            workspaceId: 6,
            durationSeconds: 2617,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 60,
                    meetingId: 13,
                    userId: 2,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 42,
        userId: 3,
        meetingId: 12,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 1856,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 15).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 12,
            title: 'Projectli Planning',
            slugId: 'v20Sho-apCSHwnOT9G0uDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 15).toISOString(),
            workspaceId: 6,
            durationSeconds: 2773,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 61,
                    meetingId: 12,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 62,
                    meetingId: 12,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 63,
                    meetingId: 12,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 64,
                    meetingId: 12,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 65,
                    meetingId: 12,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 66,
                    meetingId: 12,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 67,
                    meetingId: 12,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 41,
        userId: 3,
        meetingId: 12,
        action: 'MEET_CALL_ENDED',
        eventId: 1855,
        endpoint: 'boq_hlane_ck9cft6qzyE',
        workspaceId: 6,
        date: subDays(new Date(), 15).toISOString(),
        durationSeconds: 1766,
        audioSendSeconds: 572,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 12,
            title: 'Projectli Planning',
            slugId: 'v20Sho-apCSHwnOT9G0uDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 15).toISOString(),
            workspaceId: 6,
            durationSeconds: 2773,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 61,
                    meetingId: 12,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 62,
                    meetingId: 12,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 63,
                    meetingId: 12,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 64,
                    meetingId: 12,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 65,
                    meetingId: 12,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 66,
                    meetingId: 12,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 67,
                    meetingId: 12,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 40,
        userId: 11,
        meetingId: 12,
        action: 'MEET_CALL_ENDED',
        eventId: 1854,
        endpoint: 'boq_hlane_Es0VROWeG0F',
        workspaceId: 6,
        date: subDays(new Date(), 15).toISOString(),
        durationSeconds: 1758,
        audioSendSeconds: 1758,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 12,
            title: 'Projectli Planning',
            slugId: 'v20Sho-apCSHwnOT9G0uDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 15).toISOString(),
            workspaceId: 6,
            durationSeconds: 2773,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 61,
                    meetingId: 12,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 62,
                    meetingId: 12,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 63,
                    meetingId: 12,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 64,
                    meetingId: 12,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 65,
                    meetingId: 12,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 66,
                    meetingId: 12,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 67,
                    meetingId: 12,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 39,
        userId: 1,
        meetingId: 12,
        action: 'MEET_CALL_ENDED',
        eventId: 1853,
        endpoint: 'boq_hlane_aFZXQ2oxMSr',
        workspaceId: 6,
        date: subDays(new Date(), 15).toISOString(),
        durationSeconds: 2755,
        audioSendSeconds: 696,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 12,
            title: 'Projectli Planning',
            slugId: 'v20Sho-apCSHwnOT9G0uDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 15).toISOString(),
            workspaceId: 6,
            durationSeconds: 2773,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 61,
                    meetingId: 12,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 62,
                    meetingId: 12,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 63,
                    meetingId: 12,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 64,
                    meetingId: 12,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 65,
                    meetingId: 12,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 66,
                    meetingId: 12,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 67,
                    meetingId: 12,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 38,
        userId: 9,
        meetingId: 12,
        action: 'MEET_CALL_ENDED',
        eventId: 1852,
        endpoint: 'boq_hlane_jqlaa0vranr',
        workspaceId: 6,
        date: subDays(new Date(), 15).toISOString(),
        durationSeconds: 2736,
        audioSendSeconds: 1063,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 12,
            title: 'Projectli Planning',
            slugId: 'v20Sho-apCSHwnOT9G0uDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 15).toISOString(),
            workspaceId: 6,
            durationSeconds: 2773,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 61,
                    meetingId: 12,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 62,
                    meetingId: 12,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 63,
                    meetingId: 12,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 64,
                    meetingId: 12,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 65,
                    meetingId: 12,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 66,
                    meetingId: 12,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 67,
                    meetingId: 12,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 37,
        userId: 7,
        meetingId: 12,
        action: 'MEET_CALL_ENDED',
        eventId: 1851,
        endpoint: 'boq_hlane_cIgYwQ2qxGk',
        workspaceId: 6,
        date: subDays(new Date(), 15).toISOString(),
        durationSeconds: 2773,
        audioSendSeconds: 104,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 12,
            title: 'Projectli Planning',
            slugId: 'v20Sho-apCSHwnOT9G0uDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 15).toISOString(),
            workspaceId: 6,
            durationSeconds: 2773,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 61,
                    meetingId: 12,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 62,
                    meetingId: 12,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 63,
                    meetingId: 12,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 64,
                    meetingId: 12,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 65,
                    meetingId: 12,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 66,
                    meetingId: 12,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 67,
                    meetingId: 12,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 36,
        userId: 1,
        meetingId: 11,
        action: 'MEET_CALL_ENDED',
        eventId: 1701,
        endpoint: 'boq_hlane_3kGGABPpEj6',
        workspaceId: 6,
        date: subDays(new Date(), 14).toISOString(),
        durationSeconds: 98,
        audioSendSeconds: 98,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 11,
            title: 'Projectli Daily',
            slugId: '46AejdMy0J9R7B_c8di4DxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 14).toISOString(),
            workspaceId: 6,
            durationSeconds: 98,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 69,
                    meetingId: 11,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 70,
                    meetingId: 11,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 71,
                    meetingId: 11,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 72,
                    meetingId: 11,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 73,
                    meetingId: 11,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 74,
                    meetingId: 11,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 35,
        userId: 3,
        meetingId: 10,
        action: 'MEET_CALL_ENDED',
        eventId: 1700,
        endpoint: 'boq_hlane_miZQOGwFD8m',
        workspaceId: 6,
        date: subDays(new Date(), 14).toISOString(),
        durationSeconds: 247,
        audioSendSeconds: 247,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 10,
            title: 'Volodymyr Noha, Oleh Melnychuk, Yevheniia Danylchuk, Oleksandr Burda',
            slugId: '6QOqBhWf_U4B03dkLHPDDxIPOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 14).toISOString(),
            workspaceId: 6,
            durationSeconds: 247,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 49,
                    meetingId: 10,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 50,
                    meetingId: 10,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 51,
                    meetingId: 10,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 52,
                    meetingId: 10,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 34,
        userId: 1,
        meetingId: 10,
        action: 'MEET_CALL_ENDED',
        eventId: 1699,
        endpoint: 'boq_hlane_YjJydipypTz',
        workspaceId: 6,
        date: subDays(new Date(), 14).toISOString(),
        durationSeconds: 204,
        audioSendSeconds: 97,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 10,
            title: 'Volodymyr Noha, Oleh Melnychuk, Yevheniia Danylchuk, Oleksandr Burda',
            slugId: '6QOqBhWf_U4B03dkLHPDDxIPOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 14).toISOString(),
            workspaceId: 6,
            durationSeconds: 247,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 49,
                    meetingId: 10,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 50,
                    meetingId: 10,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 51,
                    meetingId: 10,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 52,
                    meetingId: 10,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 33,
        userId: 9,
        meetingId: 10,
        action: 'MEET_CALL_ENDED',
        eventId: 1698,
        endpoint: 'boq_hlane_oqRYpSgiqM1',
        workspaceId: 6,
        date: subDays(new Date(), 14).toISOString(),
        durationSeconds: 234,
        audioSendSeconds: 51,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 10,
            title: 'Volodymyr Noha, Oleh Melnychuk, Yevheniia Danylchuk, Oleksandr Burda',
            slugId: '6QOqBhWf_U4B03dkLHPDDxIPOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 14).toISOString(),
            workspaceId: 6,
            durationSeconds: 247,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 49,
                    meetingId: 10,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 50,
                    meetingId: 10,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 51,
                    meetingId: 10,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 52,
                    meetingId: 10,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 32,
        userId: 7,
        meetingId: 10,
        action: 'MEET_CALL_ENDED',
        eventId: 1697,
        endpoint: 'boq_hlane_0LARM9PVARr',
        workspaceId: 6,
        date: subDays(new Date(), 14).toISOString(),
        durationSeconds: 214,
        audioSendSeconds: 116,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 10,
            title: 'Volodymyr Noha, Oleh Melnychuk, Yevheniia Danylchuk, Oleksandr Burda',
            slugId: '6QOqBhWf_U4B03dkLHPDDxIPOA8MCwMyBwiKAiAAGAMI',
            calendarId: null,
            date: subDays(new Date(), 14).toISOString(),
            workspaceId: 6,
            durationSeconds: 247,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 49,
                    meetingId: 10,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 50,
                    meetingId: 10,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 51,
                    meetingId: 10,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 52,
                    meetingId: 10,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 31,
        userId: 3,
        meetingId: 9,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 1564,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 13).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 9,
            title: 'Projectli Daily',
            slugId: 'uYYOtyDpQ6-CwMriN6JpDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 13).toISOString(),
            workspaceId: 6,
            durationSeconds: 441,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 53,
                    meetingId: 9,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 54,
                    meetingId: 9,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 55,
                    meetingId: 9,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 56,
                    meetingId: 9,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 57,
                    meetingId: 9,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 58,
                    meetingId: 9,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 30,
        userId: 3,
        meetingId: 9,
        action: 'MEET_CALL_ENDED',
        eventId: 1563,
        endpoint: 'boq_hlane_FSRG9rI6l2p',
        workspaceId: 6,
        date: subDays(new Date(), 13).toISOString(),
        durationSeconds: 357,
        audioSendSeconds: 293,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 9,
            title: 'Projectli Daily',
            slugId: 'uYYOtyDpQ6-CwMriN6JpDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 13).toISOString(),
            workspaceId: 6,
            durationSeconds: 441,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 53,
                    meetingId: 9,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 54,
                    meetingId: 9,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 55,
                    meetingId: 9,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 56,
                    meetingId: 9,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 57,
                    meetingId: 9,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 58,
                    meetingId: 9,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 29,
        userId: 9,
        meetingId: 9,
        action: 'MEET_CALL_ENDED',
        eventId: 1562,
        endpoint: 'boq_hlane_a4dP5yfJEOr',
        workspaceId: 6,
        date: subDays(new Date(), 13).toISOString(),
        durationSeconds: 441,
        audioSendSeconds: 102,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 9,
            title: 'Projectli Daily',
            slugId: 'uYYOtyDpQ6-CwMriN6JpDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 13).toISOString(),
            workspaceId: 6,
            durationSeconds: 441,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 53,
                    meetingId: 9,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 54,
                    meetingId: 9,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 55,
                    meetingId: 9,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 56,
                    meetingId: 9,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 57,
                    meetingId: 9,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 58,
                    meetingId: 9,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 28,
        userId: 1,
        meetingId: 9,
        action: 'MEET_CALL_ENDED',
        eventId: 1561,
        endpoint: 'boq_hlane_RWr0tf6DOjc',
        workspaceId: 6,
        date: subDays(new Date(), 13).toISOString(),
        durationSeconds: 427,
        audioSendSeconds: 243,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 9,
            title: 'Projectli Daily',
            slugId: 'uYYOtyDpQ6-CwMriN6JpDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 13).toISOString(),
            workspaceId: 6,
            durationSeconds: 441,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 53,
                    meetingId: 9,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 54,
                    meetingId: 9,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 55,
                    meetingId: 9,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 56,
                    meetingId: 9,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 57,
                    meetingId: 9,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 58,
                    meetingId: 9,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 27,
        userId: 7,
        meetingId: 9,
        action: 'MEET_CALL_ENDED',
        eventId: 1560,
        endpoint: 'boq_hlane_QZh1Tjd6Og8',
        workspaceId: 6,
        date: subDays(new Date(), 13).toISOString(),
        durationSeconds: 439,
        audioSendSeconds: 83,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 9,
            title: 'Projectli Daily',
            slugId: 'uYYOtyDpQ6-CwMriN6JpDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 13).toISOString(),
            workspaceId: 6,
            durationSeconds: 441,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 53,
                    meetingId: 9,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 54,
                    meetingId: 9,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 55,
                    meetingId: 9,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 56,
                    meetingId: 9,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 57,
                    meetingId: 9,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 58,
                    meetingId: 9,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 26,
        userId: 1,
        meetingId: 8,
        action: 'MEET_CALL_ENDED',
        eventId: 1242,
        endpoint: 'boq_hlane_s1WjZK0F5XN',
        workspaceId: 6,
        date: subDays(new Date(), 11).toISOString(),
        durationSeconds: 95,
        audioSendSeconds: 84,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 8,
            title: 'Projectli Daily',
            slugId: 'rVO__UpRf6JL5SboqSQrDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 11).toISOString(),
            workspaceId: 6,
            durationSeconds: 123,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 42,
                    meetingId: 8,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 43,
                    meetingId: 8,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 44,
                    meetingId: 8,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 45,
                    meetingId: 8,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 46,
                    meetingId: 8,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 47,
                    meetingId: 8,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 25,
        userId: 9,
        meetingId: 8,
        action: 'MEET_CALL_ENDED',
        eventId: 1241,
        endpoint: 'boq_hlane_vvyGkitwVE1',
        workspaceId: 6,
        date: subDays(new Date(), 11).toISOString(),
        durationSeconds: 123,
        audioSendSeconds: 101,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 8,
            title: 'Projectli Daily',
            slugId: 'rVO__UpRf6JL5SboqSQrDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 11).toISOString(),
            workspaceId: 6,
            durationSeconds: 123,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 42,
                    meetingId: 8,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 43,
                    meetingId: 8,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 44,
                    meetingId: 8,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 45,
                    meetingId: 8,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 46,
                    meetingId: 8,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 47,
                    meetingId: 8,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 24,
        userId: 11,
        meetingId: 7,
        action: 'MEET_CALL_ENDED',
        eventId: 1069,
        endpoint: 'boq_hlane_3IRkVRDiA5e',
        workspaceId: 6,
        date: subDays(new Date(), 9).toISOString(),
        durationSeconds: 3771,
        audioSendSeconds: 3771,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 7,
            title: 'Vitalii / Oleg',
            slugId: 'T_qGn60vg7irl96y1GUcDxIUOA8MCwMyBwiKAiAAGAMI',
            calendarId: 3,
            date: subDays(new Date(), 9).toISOString(),
            workspaceId: 6,
            durationSeconds: 3828,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 32,
                    meetingId: 7,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 33,
                    meetingId: 7,
                    userId: 13,
                    isExternal: true,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 23,
        userId: 13,
        meetingId: 7,
        action: 'MEET_CALL_ENDED',
        eventId: 1068,
        endpoint: 'boq_hlane_31xxX1mGaj5',
        workspaceId: 6,
        date: subDays(new Date(), 9).toISOString(),
        durationSeconds: 3828,
        audioSendSeconds: 3827,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: true,
        meeting: {
            id: 7,
            title: 'Vitalii / Oleg',
            slugId: 'T_qGn60vg7irl96y1GUcDxIUOA8MCwMyBwiKAiAAGAMI',
            calendarId: 3,
            date: subDays(new Date(), 9).toISOString(),
            workspaceId: 6,
            durationSeconds: 3828,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 32,
                    meetingId: 7,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 33,
                    meetingId: 7,
                    userId: 13,
                    isExternal: true,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 22,
        userId: 11,
        meetingId: 6,
        action: 'MEET_CALL_ENDED',
        eventId: 933,
        endpoint: 'boq_hlane_jvsOOTqN4W9',
        workspaceId: 6,
        date: subDays(new Date(), 7).toISOString(),
        durationSeconds: 1518,
        audioSendSeconds: 1517,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 6,
            title: 'Projectli Planning',
            slugId: 'VPGJMZUQ-A9KLpnZE1aZDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 7).toISOString(),
            workspaceId: 6,
            durationSeconds: 1576,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 34,
                    meetingId: 6,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 35,
                    meetingId: 6,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 36,
                    meetingId: 6,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 37,
                    meetingId: 6,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 38,
                    meetingId: 6,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 39,
                    meetingId: 6,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 40,
                    meetingId: 6,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 21,
        userId: 7,
        meetingId: 6,
        action: 'MEET_CALL_ENDED',
        eventId: 930,
        endpoint: 'boq_hlane_kFBEvDPMlfK',
        workspaceId: 6,
        date: subDays(new Date(), 7).toISOString(),
        durationSeconds: 1558,
        audioSendSeconds: 281,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 6,
            title: 'Projectli Planning',
            slugId: 'VPGJMZUQ-A9KLpnZE1aZDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 7).toISOString(),
            workspaceId: 6,
            durationSeconds: 1576,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 34,
                    meetingId: 6,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 35,
                    meetingId: 6,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 36,
                    meetingId: 6,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 37,
                    meetingId: 6,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 38,
                    meetingId: 6,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 39,
                    meetingId: 6,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 40,
                    meetingId: 6,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 20,
        userId: 9,
        meetingId: 6,
        action: 'MEET_CALL_ENDED',
        eventId: 927,
        endpoint: 'boq_hlane_OEyih0hT5eV',
        workspaceId: 6,
        date: subDays(new Date(), 7).toISOString(),
        durationSeconds: 1576,
        audioSendSeconds: 1283,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 6,
            title: 'Projectli Planning',
            slugId: 'VPGJMZUQ-A9KLpnZE1aZDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 7).toISOString(),
            workspaceId: 6,
            durationSeconds: 1576,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 34,
                    meetingId: 6,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 35,
                    meetingId: 6,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 36,
                    meetingId: 6,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 37,
                    meetingId: 6,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 38,
                    meetingId: 6,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 39,
                    meetingId: 6,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 40,
                    meetingId: 6,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 19,
        userId: 3,
        meetingId: 5,
        action: 'MEET_CALL_ENDED',
        eventId: 732,
        endpoint: 'boq_hlane_KrRDJBPgX3A',
        workspaceId: 6,
        date: subDays(new Date(), 6).toISOString(),
        durationSeconds: 183,
        audioSendSeconds: 183,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 5,
            title: 'Projectli Daily',
            slugId: '1Yqp5ixIYYK3xIygvbcLDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 6).toISOString(),
            workspaceId: 6,
            durationSeconds: 187,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 25,
                    meetingId: 5,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 26,
                    meetingId: 5,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 27,
                    meetingId: 5,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 28,
                    meetingId: 5,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 29,
                    meetingId: 5,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 30,
                    meetingId: 5,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 18,
        userId: 1,
        meetingId: 5,
        action: 'MEET_CALL_ENDED',
        eventId: 731,
        endpoint: 'boq_hlane_VWucAjtudPS',
        workspaceId: 6,
        date: subDays(new Date(), 6).toISOString(),
        durationSeconds: 173,
        audioSendSeconds: 76,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 5,
            title: 'Projectli Daily',
            slugId: '1Yqp5ixIYYK3xIygvbcLDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 6).toISOString(),
            workspaceId: 6,
            durationSeconds: 187,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 25,
                    meetingId: 5,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 26,
                    meetingId: 5,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 27,
                    meetingId: 5,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 28,
                    meetingId: 5,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 29,
                    meetingId: 5,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 30,
                    meetingId: 5,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 17,
        userId: 7,
        meetingId: 5,
        action: 'MEET_CALL_ENDED',
        eventId: 730,
        endpoint: 'hub_ios_KjcnO45PovU',
        workspaceId: 6,
        date: subDays(new Date(), 6).toISOString(),
        durationSeconds: 182,
        audioSendSeconds: 50,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 5,
            title: 'Projectli Daily',
            slugId: '1Yqp5ixIYYK3xIygvbcLDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 6).toISOString(),
            workspaceId: 6,
            durationSeconds: 187,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 25,
                    meetingId: 5,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 26,
                    meetingId: 5,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 27,
                    meetingId: 5,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 28,
                    meetingId: 5,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 29,
                    meetingId: 5,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 30,
                    meetingId: 5,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 16,
        userId: 9,
        meetingId: 5,
        action: 'MEET_CALL_ENDED',
        eventId: 729,
        endpoint: 'boq_hlane_fh8h30CPhj7',
        workspaceId: 6,
        date: subDays(new Date(), 6).toISOString(),
        durationSeconds: 187,
        audioSendSeconds: 56,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 5,
            title: 'Projectli Daily',
            slugId: '1Yqp5ixIYYK3xIygvbcLDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 6).toISOString(),
            workspaceId: 6,
            durationSeconds: 187,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 25,
                    meetingId: 5,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 26,
                    meetingId: 5,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 27,
                    meetingId: 5,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 28,
                    meetingId: 5,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 29,
                    meetingId: 5,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 30,
                    meetingId: 5,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 15,
        userId: 7,
        meetingId: 4,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 434,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 5).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 4,
            title: 'Projectli Daily',
            slugId: 'S_gTiC-yCPWp0bvEkqKEDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 5).toISOString(),
            workspaceId: 6,
            durationSeconds: 412,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 10,
                    meetingId: 4,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 11,
                    meetingId: 4,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 12,
                    meetingId: 4,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 13,
                    meetingId: 4,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 14,
                    meetingId: 4,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 15,
                    meetingId: 4,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 14,
        userId: 3,
        meetingId: 4,
        action: 'MEET_CALL_ENDED',
        eventId: 433,
        endpoint: 'boq_hlane_sEXdb0AiRve',
        workspaceId: 6,
        date: subDays(new Date(), 5).toISOString(),
        durationSeconds: 393,
        audioSendSeconds: 382,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 4,
            title: 'Projectli Daily',
            slugId: 'S_gTiC-yCPWp0bvEkqKEDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 5).toISOString(),
            workspaceId: 6,
            durationSeconds: 412,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 10,
                    meetingId: 4,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 11,
                    meetingId: 4,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 12,
                    meetingId: 4,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 13,
                    meetingId: 4,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 14,
                    meetingId: 4,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 15,
                    meetingId: 4,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 13,
        userId: 1,
        meetingId: 4,
        action: 'MEET_CALL_ENDED',
        eventId: 432,
        endpoint: 'duo_ios_FTBnPZHCZN6',
        workspaceId: 6,
        date: subDays(new Date(), 5).toISOString(),
        durationSeconds: 407,
        audioSendSeconds: 40,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 4,
            title: 'Projectli Daily',
            slugId: 'S_gTiC-yCPWp0bvEkqKEDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 5).toISOString(),
            workspaceId: 6,
            durationSeconds: 412,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 10,
                    meetingId: 4,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 11,
                    meetingId: 4,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 12,
                    meetingId: 4,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 13,
                    meetingId: 4,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 14,
                    meetingId: 4,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 15,
                    meetingId: 4,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 12,
        userId: 9,
        meetingId: 4,
        action: 'MEET_CALL_ENDED',
        eventId: 430,
        endpoint: 'boq_hlane_uXAYR1Gl6Wy',
        workspaceId: 6,
        date: subDays(new Date(), 5).toISOString(),
        durationSeconds: 412,
        audioSendSeconds: 163,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 4,
            title: 'Projectli Daily',
            slugId: 'S_gTiC-yCPWp0bvEkqKEDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 5).toISOString(),
            workspaceId: 6,
            durationSeconds: 412,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 10,
                    meetingId: 4,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 11,
                    meetingId: 4,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 12,
                    meetingId: 4,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 13,
                    meetingId: 4,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 14,
                    meetingId: 4,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 15,
                    meetingId: 4,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 11,
        userId: 7,
        meetingId: 4,
        action: 'MEET_CALL_ENDED',
        eventId: 428,
        endpoint: 'boq_hlane_XyzJsBkyGU0',
        workspaceId: 6,
        date: subDays(new Date(), 5).toISOString(),
        durationSeconds: 386,
        audioSendSeconds: 123,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 4,
            title: 'Projectli Daily',
            slugId: 'S_gTiC-yCPWp0bvEkqKEDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 5).toISOString(),
            workspaceId: 6,
            durationSeconds: 412,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 10,
                    meetingId: 4,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 11,
                    meetingId: 4,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 12,
                    meetingId: 4,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 13,
                    meetingId: 4,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 14,
                    meetingId: 4,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 15,
                    meetingId: 4,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 10,
        userId: 1,
        meetingId: 3,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 312,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 4).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 3,
            title: 'Projectli Daily',
            slugId: 'nFi_GiVlSzr3RvqbTUvfDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 4).toISOString(),
            workspaceId: 6,
            durationSeconds: 682,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 3,
                    meetingId: 3,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 4,
                    meetingId: 3,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 5,
                    meetingId: 3,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 6,
                    meetingId: 3,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 7,
                    meetingId: 3,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 8,
                    meetingId: 3,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 9,
        userId: 1,
        meetingId: 3,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 311,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 4).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 3,
            title: 'Projectli Daily',
            slugId: 'nFi_GiVlSzr3RvqbTUvfDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 4).toISOString(),
            workspaceId: 6,
            durationSeconds: 682,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 3,
                    meetingId: 3,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 4,
                    meetingId: 3,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 5,
                    meetingId: 3,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 6,
                    meetingId: 3,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 7,
                    meetingId: 3,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 8,
                    meetingId: 3,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 8,
        userId: 7,
        meetingId: 3,
        action: 'MEET_PRESENTATION_STARTED',
        eventId: 310,
        endpoint: null,
        workspaceId: 6,
        date: subDays(new Date(), 4).toISOString(),
        durationSeconds: 0,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 3,
            title: 'Projectli Daily',
            slugId: 'nFi_GiVlSzr3RvqbTUvfDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 4).toISOString(),
            workspaceId: 6,
            durationSeconds: 682,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 3,
                    meetingId: 3,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 4,
                    meetingId: 3,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 5,
                    meetingId: 3,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 6,
                    meetingId: 3,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 7,
                    meetingId: 3,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 8,
                    meetingId: 3,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 7,
        userId: 3,
        meetingId: 3,
        action: 'MEET_CALL_ENDED',
        eventId: 309,
        endpoint: 'boq_hlane_1mNUnWLCV6z',
        workspaceId: 6,
        date: subDays(new Date(), 4).toISOString(),
        durationSeconds: 653,
        audioSendSeconds: 653,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 3,
            title: 'Projectli Daily',
            slugId: 'nFi_GiVlSzr3RvqbTUvfDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 4).toISOString(),
            workspaceId: 6,
            durationSeconds: 682,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 3,
                    meetingId: 3,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 4,
                    meetingId: 3,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 5,
                    meetingId: 3,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 6,
                    meetingId: 3,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 7,
                    meetingId: 3,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 8,
                    meetingId: 3,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 6,
        userId: 9,
        meetingId: 3,
        action: 'MEET_CALL_ENDED',
        eventId: 308,
        endpoint: 'boq_hlane_ik9BQhy13tt',
        workspaceId: 6,
        date: subDays(new Date(), 4).toISOString(),
        durationSeconds: 675,
        audioSendSeconds: 34,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 3,
            title: 'Projectli Daily',
            slugId: 'nFi_GiVlSzr3RvqbTUvfDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 4).toISOString(),
            workspaceId: 6,
            durationSeconds: 682,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 3,
                    meetingId: 3,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 4,
                    meetingId: 3,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 5,
                    meetingId: 3,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 6,
                    meetingId: 3,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 7,
                    meetingId: 3,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 8,
                    meetingId: 3,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 5,
        userId: 7,
        meetingId: 3,
        action: 'MEET_CALL_ENDED',
        eventId: 307,
        endpoint: 'boq_hlane_RYZ3zvCcsg5',
        workspaceId: 6,
        date: subDays(new Date(), 4).toISOString(),
        durationSeconds: 678,
        audioSendSeconds: 221,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 3,
            title: 'Projectli Daily',
            slugId: 'nFi_GiVlSzr3RvqbTUvfDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 4).toISOString(),
            workspaceId: 6,
            durationSeconds: 682,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 3,
                    meetingId: 3,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 4,
                    meetingId: 3,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 5,
                    meetingId: 3,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 6,
                    meetingId: 3,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 7,
                    meetingId: 3,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 8,
                    meetingId: 3,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 4,
        userId: 1,
        meetingId: 3,
        action: 'MEET_CALL_ENDED',
        eventId: 306,
        endpoint: 'boq_hlane_jYTwmBca2Rx',
        workspaceId: 6,
        date: subDays(new Date(), 4).toISOString(),
        durationSeconds: 682,
        audioSendSeconds: 418,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 3,
            title: 'Projectli Daily',
            slugId: 'nFi_GiVlSzr3RvqbTUvfDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 2,
            date: subDays(new Date(), 4).toISOString(),
            workspaceId: 6,
            durationSeconds: 682,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 3,
                    meetingId: 3,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 4,
                    meetingId: 3,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 5,
                    meetingId: 3,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 6,
                    meetingId: 3,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 7,
                    meetingId: 3,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 8,
                    meetingId: 3,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 3,
        userId: 11,
        meetingId: 2,
        action: 'MEET_CALL_ENDED',
        eventId: 223,
        endpoint: 'boq_hlane_fM7y1FEcliy',
        workspaceId: 6,
        date: subDays(new Date(), 3).toISOString(),
        durationSeconds: 5980,
        audioSendSeconds: 5980,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 2,
            title: 'Vitalii / Oleg',
            slugId: '3UhQeIOqvArmJvk0wTyoDxIUOA8MCwMyBwiKAiAAGAMI',
            calendarId: 3,
            date: subDays(new Date(), 3).toISOString(),
            workspaceId: 6,
            durationSeconds: 5990,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 1,
                    meetingId: 2,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 2,
                    meetingId: 2,
                    userId: 13,
                    isExternal: true,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 2,
        userId: 13,
        meetingId: 2,
        action: 'MEET_CALL_ENDED',
        eventId: 222,
        endpoint: 'boq_hlane_tsKeNaVyQwK',
        workspaceId: 6,
        date: subDays(new Date(), 3).toISOString(),
        durationSeconds: 5990,
        audioSendSeconds: 5990,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: true,
        meeting: {
            id: 2,
            title: 'Vitalii / Oleg',
            slugId: '3UhQeIOqvArmJvk0wTyoDxIUOA8MCwMyBwiKAiAAGAMI',
            calendarId: 3,
            date: subDays(new Date(), 3).toISOString(),
            workspaceId: 6,
            durationSeconds: 5990,
            isExternalParticipantsInvolved: true,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 0).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 1,
                    meetingId: 2,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 2,
                    meetingId: 2,
                    userId: 13,
                    isExternal: true,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    },
    {
        id: 1,
        userId: 7,
        meetingId: 1,
        action: 'MEET_CALL_ENDED',
        eventId: 61,
        endpoint: 'hub_ios_VJGDBqCffcE',
        workspaceId: 6,
        date: subDays(new Date(), 1).toISOString(),
        durationSeconds: 58,
        audioSendSeconds: 0,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString(),
        isExternalMember: false,
        meeting: {
            id: 1,
            title: 'Projectli Planning',
            slugId: 'EgFA7GrUuXHwlEFoKsmcDxIQOA8MCwMyBwiKAiAAGAMI',
            calendarId: 1,
            date: subDays(new Date(), 1).toISOString(),
            workspaceId: 6,
            durationSeconds: 58,
            isExternalParticipantsInvolved: false,
            overrunDurationSeconds: 0,
            createdAt: subDays(new Date(), 1).toISOString(),
            updatedAt: subDays(new Date(), 1).toISOString(),
            organizerId: null,
            meetingGuests: [
                {
                    id: 17,
                    meetingId: 1,
                    userId: 1,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 18,
                    meetingId: 1,
                    userId: 3,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 19,
                    meetingId: 1,
                    userId: 7,
                    isExternal: false,
                    isPresentAtMeeting: true,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 20,
                    meetingId: 1,
                    userId: 8,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 21,
                    meetingId: 1,
                    userId: 9,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 22,
                    meetingId: 1,
                    userId: 10,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                },
                {
                    id: 23,
                    meetingId: 1,
                    userId: 11,
                    isExternal: false,
                    isPresentAtMeeting: false,
                    createdAt: subDays(new Date(), 0).toISOString(),
                    updatedAt: subDays(new Date(), 0).toISOString()
                }
            ]
        }
    }
];
